// This is injected by esbuild into every js files to avoid many imports
// https://esbuild.github.io/api/#inject

import * as Sentry from "@sentry/browser";
import $ from "jquery";
import jQuery from "jquery";

import _ from "lodash";

export { Sentry, $, jQuery, _ };
